import Button from "react-bootstrap/Button";
import Query from "../../common/Query";
import ListItem from "./components/PageListItem";
import PAGES_QUERY from "./queries/PAGES_QUERY";
import { useNavigate } from "react-router-dom";
import TableList from "../components/TableList";

const PageList = () => {
  const navigate = useNavigate();
  const listItems = () => (
    <Query query={PAGES_QUERY}>
      {({ data: { pages } }: { data: { pages: any[] } }) => {
        const list = pages.map((page, i) => (
          <ListItem page={page} key={page.id} />
        ));
        return (
          <>
            <tbody>{list}</tbody>
            <Button
              className="my-4"
              onClick={() => navigate(`/admin/create-page/`)}
            >
              Add Page
            </Button>
          </>
        );
      }}
    </Query>
  );

  return (
    <>
      <h3 className="mt-4 mb-2">Pages</h3>
      <TableList>{listItems()}</TableList>
    </>
  );
};

export default PageList;
